import React, { useEffect, useState } from 'react';
import { Product } from '../../../data/models/product_list_response';
import { toast } from 'react-toastify';
import useCart from '../../../data/hooks/cart_hook';

export const EditVariantQuantityModal = (props: { product: Product; variantId: string; variantIndex: number; isOpen: boolean; setShowEdit: any }) => {
  const { isItemInCart, getItemInCart, addToCart, removeFromCart, updateCartQuantity } = useCart();
  const cartQuantity = getItemInCart(props.product.storeProductId)?.cartQuantity;
  const [updatedQuantity, setUpdatedQuantity] = useState(cartQuantity);

  useEffect(() => {
    console.log('ORIF');
    console.log(props.product);
  }, []);

  return (
    <dialog id="quantityEditModal-with-var" className="modal">
      <div className="modal-box">
        <form method="dialog">
          {/* if there is a button in form, it will close the modal */}
          <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
        </form>
        <h3 className="font-bold text-lg">Edit quantity</h3>
        <div className="modal-body relative p-4">
          <div className="text-center mb-2">{props.product.productVariants[props.variantIndex].variantName}</div>
          <div className="flex justify-center">
            <div className="mb-3 xl:w-96">
              <div className="input-group relative flex flex-row items-stretch w-full mb-4 rounded">
                <input
                  type="number"
                  className="form-control relative flex-auto min-w-0 block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-primaryViolet focus:outline-none"
                  id="productQuantityInput"
                  placeholder="Enter quantity"
                  autoFocus={true}
                  onFocus={(e: any) => e.currentTarget.select()}
                  value={updatedQuantity}
                  onChange={(e) => {
                    if (!e.currentTarget.value) {
                      setUpdatedQuantity(Number.parseFloat(e.target.value ?? 0));
                    } else if (
                      Number.parseFloat(e.target.value) <= props.product.productVariants[props.variantIndex].quantity &&
                      Number.parseFloat(e.target.value) > -1
                    ) {
                      setUpdatedQuantity(Number.parseFloat(e.target.value));
                    } else {
                      toast.dismiss();
                      toast.error('Stock unavailable', { position: 'bottom-center' });
                    }
                  }}
                />
                <span
                  className="input-group-text flex items-center px-3 py-1.5 text-base font-normal text-gray-600 text-center whitespace-nowrap rounded-lg border border-gray-300"
                  id="basic-addon2"
                >
                  {props.product.productUnit.productUnitName}
                </span>
              </div>
            </div>
          </div>
        </div>
        <form
          method="dialog"
          className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md"
        >
          <button
            data-bs-dismiss="modal"
            onClick={() => {
              if (Number.isNaN(updatedQuantity)) {
                updateCartQuantity(props.product, 0, props.variantId);
              } else {
                updateCartQuantity(props.product, updatedQuantity ?? 0, props.variantId);
              }
            }}
            className="inline-block px-6 py-2.5 bg-primaryViolet text-white font-medium text-xs leading-tight uppercase rounded-lg shadow-md hover:bg-primaryViolet focus:bg-primaryViolet focus:outline-none focus:ring-0 active:bg-primaryViolet active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Save
          </button>
        </form>
      </div>
    </dialog>
  );
};
